import { Button, Descriptions, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { FormatDate } from '../../../../constants';
import { Tags } from '../../../shared/tags';
import { StaffEditContainerStaffUserFieldsFragment, StaffViewContainerStaffUserCurrentFieldsFragment } from '../../../../generated';

interface StaffViewProps {
  staffData: StaffEditContainerStaffUserFieldsFragment;
  currentStaffData: StaffViewContainerStaffUserCurrentFieldsFragment;
}

export const StaffView: React.FC<StaffViewProps> = (props) => {
  const navigate = useNavigate();
  const onEditClick = () => {
    navigate('../edit');
  };

  console.log('props.currentStaffData', props.currentStaffData?.role);
  return (
    <div>
      <div className="flex justify-between w-full pr-10">
        <div className="flex gap-2">
          <Typography.Title level={5}>Staff Information</Typography.Title>
        </div>
        <Button
          type="primary"
          disabled={
            props.currentStaffData.id === props.staffData.id ||
            !(
              props.currentStaffData.role?.permissions.staffUserPermissions.canAddOrRemoveTags ||
              props.currentStaffData.role?.permissions.staffUserPermissions.canAssignRoles ||
              props.currentStaffData.role?.permissions.staffUserPermissions.canBlockAccess
            )
          }
          onClick={onEditClick}
        >
          Edit
        </Button>
      </div>
      <Descriptions
        style={{ marginBottom: '20px' }}
        size="small"
        layout="vertical"
        column={3}
        items={[
          {
            label: 'Id',
            children: props.staffData.id
          },
          {
            label: 'Created At',
            children: FormatDate(props.staffData.createdAt)
          },
          {
            label: 'Updated At',
            children: FormatDate(props.staffData.updatedAt)
          }
        ]}
      />
      <Descriptions
        size="small"
        layout="vertical"
        column={3}
        items={[
          {
            label: 'First Name',
            children: props.staffData.firstName
          },
          {
            label: 'Last Name',
            children: props.staffData.lastName
          },
          {
            label: '',
            children: ''
          },
          {
            label: 'Role',
            children: props.staffData.role?.roleName
          },
          {
            label: 'Access Blocked',
            children: props.staffData.accessBlocked ? 'Yes' : 'No'
          },
          {
            label: '',
            children: ''
          },
          {
            label: 'Tags',
            children: props.staffData.tags?.length === 0 ? 'N/A' : <Tags tagsData={props.staffData.tags as string[]} readonly={true} />
          }
        ]}
      />
    </div>
  );
};
